import { useState, useEffect } from 'react'
import useTranslate from '../../../i18n/useTranslate'
import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../umServiceURL'

export type OptType = {
    label: string
    value: string
}

type Resulttype = {
    irb_id: number
    name_en: string
    name_th: string
}
type responseType = {
    message: string
    status: number
    result: Resulttype[]
}

const useIRB = () => {
    const translate = useTranslate()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const callApi = useCallApi()
    const [irb, setIrb] = useState<OptType[]>([])

    const getIRB = async () => {
        const { data } = await callApi.axiosGet<responseType>({
            url: umServinceURL.getIrb,
        })
        const lookup = data.result.map((itm) => {
            const container: OptType = {
                ['label']: lang === 'en' ? itm.name_en : itm.name_th,
                ['value']: itm.irb_id.toString(),
            }

            return container
        })
        setIrb(lookup)
        return lookup
    }

    useEffect(() => {
        getIRB()
    }, [translate.languageStore.currentLanguage])

    return { irb, getIRB }
}

export default useIRB
